angular.module('FlexyBeautyApp.services')
    .factory('ModelDataUtil', [function () {
        let modelDataUtil = {
            convertMapToArray : function(object, array){
                array = [];
                for (let key in object) {
                    array.push(object[key]);
                    delete object[key];
                }
                return array;
            },
            convertObjectToArray: (object, indexArray) => {
                const oldObject = indexArray.reduce((accumulatorObject, currentItem) => {
                    if (currentItem.id) {
                        accumulatorObject[currentItem.id] = currentItem;
                    }
                    return accumulatorObject;
                }, {});

                const newObject = {
                    ...object,
                    ...oldObject,
                };

                return Object.values(newObject);
            }
        };

        return modelDataUtil;
    }]);


// WEBPACK FOOTER //
// ./js/services/models/ModelDataUtil.js